import { userManager } from '../helpers/managers';

export const updateUserMetadata = (userId, meta) =>
  userManager.update(userId, meta);
